import { FinancePenaltiesTable } from "components/Tables/FinancePenaltiesTable/FinancePenaltiesTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getFinanceHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/")({
    component: FinancePenaltyPage,
    staticData: {
        permissions: [],
        //permissions: [PermissionEnum.FinancePenaltyView],
        showInSideMenu: false,
        label: "pages.finance.penalty.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.finance.penalty.title"),
        };
    },
});

function FinancePenaltyPage() {
    return (
        <TenantPage headerNavigationItems={getFinanceHeaderItems}>
            <FinancePenaltiesTable />
        </TenantPage>
    );
}
